import {Profile} from '@models';

export function buildProfileSignature(profile: Profile): string {
	const updatedAt = profile.updatedAt ?? '';
	const createdAt = profile.createdAt ?? '';
	const lang = profile.lang?.shortCode ?? '';
	const hasImage = profile.hasImage ?? '';
	const imgUrl = profile.imgUrl ?? '';
	return `${profile.uuid}|${updatedAt}|${createdAt}|${lang}|${hasImage}|${imgUrl}`;
}

export function coerceTimestamp(value: unknown): number {
	if (value instanceof Date) {
		return value.getTime();
	}
	if (typeof value === 'number' && !Number.isNaN(value)) {
		return value;
	}
	if (typeof value === 'string') {
		const parsed = Date.parse(value);
		return Number.isNaN(parsed) ? 0 : parsed;
	}
	return 0;
}
